<ng-container *ngIf="isTrue">

    <ngx-ui-loader></ngx-ui-loader>
</ng-container>
<router-outlet></router-outlet>
